// // import axios from 'axios';

// // const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// // const apiClient = axios.create({
// //   baseURL: API_BASE_URL,
// //   timeout: 30000,
// //   headers: { 'Content-Type': 'application/json' },
// // });

// // apiClient.interceptors.request.use(
// //   (config) => {
// //     const token = localStorage.getItem('authToken');
// //     if (token) config.headers.Authorization = `Bearer ${token}`;
// //     return config;
// //   },
// //   (error) => Promise.reject(error)
// // );

// // apiClient.interceptors.response.use(
// //   (response) => response.data,
// //   (error) => {
// //     if (error.response?.status === 401) {
// //       localStorage.removeItem('authToken');
// //       window.location.href = '/login';
// //     }
// //     return Promise.reject(error.response?.data || error.message);
// //   }
// // );

// // export default apiClient;
// import axios from 'axios';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// const apiClient = axios.create({
//   baseURL: API_BASE_URL,
//   timeout: 5000, // ← reduced from 30000 so it fails faster
//   headers: { 'Content-Type': 'application/json' },
// });

// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('authToken');
//     if (token) config.headers.Authorization = `Bearer ${token}`;
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// apiClient.interceptors.response.use(
//   (response) => response.data,
//   (error) => {
//     // 401 — logout and redirect
//     if (error.response?.status === 401) {
//       localStorage.removeItem('authToken');
//       window.location.href = '/login';
//       return;
//     }

//     // Network Error / backend not running — return empty data silently
//     if (!error.response) {
//       console.warn('API unavailable, returning empty data for:', error.config?.url);
//       return Promise.resolve({
//         data:        [],
//         courts:      [],
//         tournaments: [],
//         coaches:     [],
//         bookings:    [],
//         matches:     [],
//         user:        null,
//         total:       0,
//       });
//     }

//     return Promise.reject(error.response?.data || error.message);
//   }
// );

// export default apiClient;
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("REACT_APP_API_BASE_URL =", process.env.REACT_APP_API_BASE_URL);
console.log("BASE_URL =", BASE_URL);

const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

const refreshClient = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

const PUBLIC_ROUTES = [
    '/login',
    '/login/refresh-token',
    '/vendor/register',
    '/vendor',
    '/forgot-password',
    '/sports',
];

const isPublicRoute = (url = '') => {
    return PUBLIC_ROUTES.some((route) => url.includes(route));
};

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((promise) => {
        if (error) {
            promise.reject(error);
        } else {
            promise.resolve(token);
        }
    });
    failedQueue = [];
};

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;

        if (!error.response) {
            return Promise.reject(error);
        }

        const status = error.response.status;
        const requestUrl = original?.url || '';

        if (
            status === 401 &&
            !original?._retry &&
            !isPublicRoute(requestUrl)
        ) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then((token) => {
                        original.headers.Authorization = `Bearer ${token}`;
                        return apiClient(original);
                    })
                    .catch((err) => Promise.reject(err));
            }

            original._retry = true;
            isRefreshing = true;

            try {
                const res = await refreshClient.post('/login/refresh-token');
                const newToken = res?.data?.data?.accessToken;

                if (!newToken) {
                    throw new Error('No access token returned from refresh-token');
                }

                localStorage.setItem('authToken', newToken);
                apiClient.defaults.headers.common.Authorization = `Bearer ${newToken}`;
                processQueue(null, newToken);

                original.headers.Authorization = `Bearer ${newToken}`;
                return apiClient(original);
            } catch (refreshError) {
                processQueue(refreshError, null);
                localStorage.removeItem('authToken');
                localStorage.removeItem('authUser');
                window.location.href = '/login';
                return Promise.reject(refreshError?.response?.data || refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error.response?.data || error);
    }
);

export default apiClient;
export { refreshClient };